export enum ListView {
  MY_LISTS = 1,
  DETAIL_CURRENT = 2,
  DETAIL_ARCHIVE = 3,
  DETAIL_HISTORY = 4,
  DETAIL_EDIT = 5,
  DETAIL_DETAIL = 6,
  BROWSE = 7,
  ADD = 8,
  ARCHIVE = 9,
  USER_DETAIL = 10,
  RESTORE = 11,
  LIST_ARCHIVE_ACTION = 12,
  DETAIL_SEND_EMAIL = 13,
}
